import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const StageContext = createContext();

export const StageProvider = ({ children }) => {
  const [selectedStage, setSelectedStage] = useState(null);
  const [isStageSelected, setIsStageSelected] = useState(false);

  const updateStage = useCallback((stage) => {
    setSelectedStage(stage);
    setIsStageSelected(!!stage);
  }, []);

  const value = useMemo(() => ({
    selectedStage,
    isStageSelected,
    updateStage
  }), [selectedStage, isStageSelected, updateStage]);

  return (
    <StageContext.Provider value={value}>
      {children}
    </StageContext.Provider>
  );
};

export const useStageContext = () => {
  const context = useContext(StageContext);
  if (!context) {
    throw new Error('useStageContext must be used within a StageProvider');
  }
  return context;
};
